module.exports = __webpack_public_path__ + "static/media/colicoli16.2b0a8922.webp";